import { Box, Typography } from '@mui/material';

import { I18n } from '../../../i18n';
import { TextButton } from '../../common/Buttons';
import { Color } from '~/constants';
import { theme } from '~/theme';

interface Props {
  title?: string;
  description: string;
  onView: () => void;
  iconSrc?: string;
  populatePOIref?: any;
  POIid?: string;
  setBackground?: boolean;
}

export const PointOfInterest = ({
  title,
  description,
  onView,
  iconSrc,
  populatePOIref,
  POIid,
  setBackground,
}: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        backgroundColor: setBackground ? Color.Grey100 : '',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(1),
      }}
      ref={el => populatePOIref?.(el, POIid)}
    >
      {iconSrc && (
        <Box
          sx={{
            height: 24,
            width: 24,
            mr: 1,
          }}
          component={'img'}
          src={iconSrc}
        />
      )}

      <Box>
        {title && (
          <Typography variant="body1" fontWeight={'bold'}>
            {title}
          </Typography>
        )}
        <Typography variant="body2">{description}</Typography>

        <TextButton
          onClick={onView}
          sx={{ position: 'relative', right: 10 }}
          label={I18n.t('zoneDetails.viewOnMap')}
        />
      </Box>
    </Box>
  );
};
